<form class="service-record-form" id="fg" [formGroup]="fg" novalidate (ngSubmit)="onSubmitForm()">

  <app-message-panel kind="ERROR" *ngIf="errors">{{errors}}</app-message-panel>

  <div class="row">

    <div class="col-sm-6 col-xs-12">
      <h4>Main details</h4>
      <div class="form-group">
        <mat-form-field appearance="fill">
          <mat-label>Date</mat-label>
          <input matInput formControlName="date" min="2017-01-01" [matDatepicker]="dpDate" />
          <mat-datepicker #dpDate></mat-datepicker>
          <mat-datepicker-toggle [for]="dpDate" matSuffix></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field appearance="fill">
          <mat-label>Last service date</mat-label>
          <input matInput formControlName="lastServiceDate" min="2017-01-01" [matDatepicker]="dpLastServiceDate" />
          <mat-datepicker #dpLastServiceDate></mat-datepicker>
          <mat-datepicker-toggle [for]="dpLastServiceDate" matSuffix></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <input type="text" matInput formControlName="lastServiceStatus" placeholder="Last service status" />
        </mat-form-field>
      </div>
      <div class="form-group flags" formGroupName="flags">
        <mat-checkbox md-no-ink class="md-primary" formControlName="mc3Used">MC3 + used?</mat-checkbox>
        <mat-checkbox md-no-ink class="md-primary" formControlName="magnaCleanseFlush">MagnaCleanse flush?</mat-checkbox>
        <mat-checkbox md-no-ink class="md-primary" formControlName="magnaCleanFitted">MagnaClean fitted?</mat-checkbox>
        <mat-checkbox md-no-ink class="md-primary" formControlName="mc1Used">MC1 used?</mat-checkbox>
        <mat-checkbox md-no-ink class="md-primary" formControlName="waterTestComplete">Water test complete?</mat-checkbox>
        <mat-checkbox md-no-ink class="md-primary" formControlName="serviceComplete">Service complete?</mat-checkbox>
      </div>
    </div>

    <div class="col-sm-6 col-xs-12" formGroupName="customer">
      <h4>Customer details</h4>
      <div class="form-group">
        <mat-form-field>
          <input type="text" matInput formControlName="customerTitle" placeholder="Title" />
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <input type="text" matInput formControlName="customerForename" placeholder="First name" />
          <mat-error>First name is required</mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <input type="text" matInput formControlName="customerSurname" placeholder="Surname" />
          <mat-error>Surname is required</mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <input type="text" matInput formControlName="customerPostcode" placeholder="Postcode" />
          <mat-error>Postcode is required</mat-error>
        </mat-form-field>
      </div>
    </div>

  </div>

  <div class="row" *ngIf="!readOnly && showSubmit">
    <div class="btn-group">
      <input class="btn background-green color-white full-width" type="submit" [value]="submitLabel" />
    </div>
  </div>

</form>
